import Repository from '../services/repository.services'

const PREFIX = 'devices/';

const state = {
    deviceList: [],
    typeDeviceList: [],
    employeeList: [],
    assignmentList: [],
    commentList: [],
    success: false
}

const getters = {
    typeDevice: (state) => state.typeDeviceList,
    devices: (state) => state.deviceList,
    assignment: (state) => state.assignmentList,
    employees: (state) => state.employeeList,
    comments: (state) => state.commentList,
}

const actions = {
    create({ commit }, data) {
        return Repository.post(data.item, `${PREFIX}${data.entity}`).then(
            response => {
                commit('SET_SUCCESS', true);
                return Promise.resolve(response.status);
            },
            error => {
                commit('SET_SUCCESS', false);
                return Promise.reject(error);
            }
        ).catch((error) => {
            return Promise.reject(error);
        });
    },
    getTypeDevices({ commit }) {
        return Repository.get(`${PREFIX}type`).then(
            response => {
                commit('SET_LIST_TYPE_DEVICES', response.data.data);
                return Promise.resolve(response.status);
            },
            error => {
                commit('SET_LIST_TYPE_DEVICES', []);
                return Promise.reject(error);
            }
        );
    },
    getDevices({ commit }) {
        return Repository.get(`${PREFIX}inventories`).then(
            response => {
                commit('SET_LIST_DEVICES', response.data.data);
                return Promise.resolve(response.status);
            },
            error => {
                commit('SET_LIST_DEVICES', []);
                return Promise.reject(error);
            }
        );
    },
    update({ commit }, data) {
        return Repository.update(data.item, `${PREFIX}${data.entity}`).then(
            response => {
                commit('SET_SUCCESS', response);
                return Promise.resolve(response.status);
            },
            error => {
                return Promise.reject(error);
            }
        );
    },
    delete({ commit }, data) {
        return Repository.delete(data.item, `${PREFIX}${data.entity}`).then(
            response => {
                commit('SET_SUCCESS', response);
                return Promise.resolve(response.status);
            },
            error => {
                return Promise.reject(error);
            }
        );
    },
    getAssignment({ commit }, uuid) {
        return Repository.get(`${PREFIX}assignment/${uuid}`).then(
            response => {
                commit('SET_LIST_ASSIGNMENTS', response.data.data);
                return Promise.resolve(response.status);
            },
            error => {
                commit('SET_LIST_ASSIGNMENTS', []);
                return Promise.reject(error);
            }
        );
    },
    getEmployee({ commit }) {
        return Repository.get(`${PREFIX}employees`).then(
            response => {
                commit('SET_LIST_EMPLOYEES', response.data.data);
                return Promise.resolve(response.status);
            },
            error => {
                commit('SET_LIST_EMPLOYEES', []);
                return Promise.reject(error);
            }
        );
    },
    getComment({ commit }) {
        return Repository.get(`${PREFIX}comments`).then(
            response => {
                commit('SET_LIST_COMMENTS', response.data.data);
                return Promise.resolve(response.status);
            },
            error => {
                commit('SET_LIST_COMMENTS', []);
                return Promise.reject(error);
            }
        );
    },
}

const mutations = {
    SET_LIST_TYPE_DEVICES(state, res) {
        state.typeDeviceList = res;
    },
    SET_LIST_DEVICES(state, res) {
        state.deviceList = res;
    },
    SET_LIST_ASSIGNMENTS(state, res) {
        state.assignmentList = res;
    },
    SET_LIST_COMMENTS(state, res) {
        state.commentList = res;
    },
    SET_LIST_EMPLOYEES(state, res) {
        state.employeeList = res;
    },
}

export const assignmentDevices = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}